



class TFAnsModel {
    constructor(ansTxt, ansImg, isRight, ansIndex) {
        this.ansTxt = ansTxt;
        this.ansImg = ansImg;
        this.relative = "";
        this.isRight = isRight;
        this.isSelected = false;
        this.ansIndex = ansIndex;
        this.type = 0;
    }


    getReviewColor = () => {
        // if (this.isSelected && !this.isRight)
        //     return {bgColor:"red",color:"white"}
        // else if (this.isRight)
        //     return {bgColor:"green",color:"white"}
        // else
        //     return {bgColor:"white",color:"#6c757d"}//color of bootstrap secondary
        if (this.isSelected && !this.isRight)
            return "#FF627F"//red
        else if (this.isRight)
            return "#58C4A4"
        else return "#CECAD3"
    }




    initFromJsonTest4You = (obj) => {

        let splite = obj.split(":")


        this.ansTxt = splite[1];

        if (this.ansTxt.charAt(0) == "\"" || this.ansTxt.charAt(0) == "'")
            this.ansTxt = this.ansTxt.substr(1);
        if (this.ansTxt.charAt(this.ansTxt.length - 1) == "\"" || this.ansTxt.charAt(this.ansTxt.length - 1) == "'")
            this.ansTxt = this.ansTxt.substr(0, this.ansTxt.length - 1);

        this.ansTxt = window.unicodeToChar(this.ansTxt)
        this.ansTxt = this.ansTxt.replaceAll("\\", "")

        // debugger
        this.isRight = false
        this.isSelected = false;

    }


    getReportAsJson = () => {

        let obj = {};
        //            obj.put("ansTxt", this.ansTxt);
        //            obj.put("ansImg", this.ansImg);
        obj.isRight = this.isRight;
        obj.isSelected = this.isSelected;
        obj.ansIndex = this.ansIndex;
        obj.type = this.type;


        return obj;

    }

    getAsJson = () => {
        let obj = {};


        obj.ansTxt = this.ansTxt;
        obj.ansImg = this.ansImg;
        obj.isRight = this.isRight;
        obj.isSelected = this.isSelected;
        obj.ansIndex = this.ansIndex;
        obj.type = this.type;

        return obj;
    }


    initFromJson = (obj) => {

        this.ansTxt = obj.ansTxt;
        //            this.ansImg = obj.getString("ansImg");
        if (obj.hasOwnProperty("isRight"))
            this.isRight = obj.isRight;
        this.isSelected = obj.isSelected;
        this.ansIndex = obj.ansIndex;
        this.type = obj.type;


    }

    initReportFromJson = (obj) => {

        //            this.ansTxt = obj.getString("ansTxt");
        //            this.ansImg = obj.getString("ansImg");
        //            this.isRight = obj.getBoolean("isRight");
        this.isSelected = obj.isSelected;
        this.ansIndex = obj.ansIndex;
        //            this.type = obj.getInt("type");

    }
}


export default TFAnsModel